var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import translations from './translations';
import MoviesImage from "./images/movies.jpg";
import TriangleImage from "./images/triangle_white.svg";
import dayjs from 'dayjs';
var RTLCinema = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLCinema, _LitElement);
  function RTLCinema() {
    var _this;
    _classCallCheck(this, RTLCinema);
    _this = _callSuper(this, RTLCinema);
    _this.language = 'lu';
    _this.type = 'random';
    _this.weekDates = {};
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLCinema, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLCinema.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      fetch("https://api-gate.rtl.lu/cinema/movies/random").then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      });
      fetch("https://api-gate.rtl.lu/cinema/cinemas").then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.cinemas = resp;
        //console.log(this.cinemas);
      });
      fetch("https://api-gate.rtl.lu/cinema/weekdates").then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.weekDates = resp;
      });
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (this.data == undefined || this.cinemas == undefined) return html(_t || (_t = _`Loading...`));
      var cinemaList = [];
      for (var lang in this.cinemas) {
        if (this.cinemas.hasOwnProperty(lang)) {
          cinemaList.push(html(_t2 || (_t2 = _`<optgroup label="${0}" >`), this._getTranslation(lang)));
          this.cinemas[lang].forEach(function (cinema) {
            cinemaList.push(html(_t3 || (_t3 = _`<option value="${0}">${0}</option>`), cinema.id, cinema.fullName));
          });
          cinemaList.push(html(_t4 || (_t4 = _`</optgroup>`)));
        }
      }
      var action = "/kultur/kino/";
      if (this.language == "fr") action = "/culture/cinema/";
      if (this.language == "en") action = "/culture/cinema/";
      return html(_t5 || (_t5 = _`
            <style>${0}</style>
            ${0}
        `), css, this.type == 'random' ? html(_t6 || (_t6 = _`
                    <div class="rtl-cinema__header">
                        <div class="cinema-filter">
                            <form class="cinema-filter__container" action="${0}" method="get">
                                <h1 class="cinema-filter__title">${0}</h1>
                                <div class="cinema-filter__cinema-container">
                                    <select class="cinema-filter cinema-filter__arrow" name="cinema">
                                        <option value="" selected>${0}</option>
                                        ${0}
                                    </select>
                                    <select class="cinema-filter cinema-filter__arrow" name="date">
                                        <option value="today">${0}</option>
                                        ${0}
                                    </select>
                                    <input class="cinema-filter__send" type="submit" value="Go">
                                </div>
                            </form><br>
                        </div>
                    </div>
                    <div class="rtl-cinema-random">
                        ${0}
                    </div>
            `), action, this._getTranslation('cinema-filter-title'), this._getTranslation('cinema'), cinemaList, this._getTranslation('today'), Object.keys(this.weekDates).map(function (dateKey) {
        var d = _this3.weekDates[dateKey];
        return html(_t7 || (_t7 = _`<option value="${0}">${0} - ${0}</option>`), dayjs(d.start).format("YYYY-MM-DD"), dayjs(d.start).format("DD/MM"), dayjs(d.end).format("DD/MM"));
      }), this.data.map(function (movie) {
        return html(_t8 || (_t8 = _`
                            <div class="rtl-cinema-random__item">
                                <a href="${0}single.php?id=${0}"><img class="rtl-cinema-random__img" src="${0}"></a>
                                <p class="rtl-cinema-random__category">${0}</p>
                                <h2 class="rtl-cinema-random__title">${0}</h2>
                                <p class="rtl-cinema-random__version">${0}</p>
                            </div>
                        `), action, movie.idMovie, movie.images.poster, movie.category, movie.title, movie.version);
      })) : ``);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        cinemas: {
          type: String
        },
        language: {
          type: String
        },
        type: {
          type: String
        },
        weekDates: {
          types: Object
        }
      };
    }
  }]);
  return RTLCinema;
}(LitElement);
export { RTLCinema as default };
window.customElements.define('rtl-cinema', RTLCinema);